<template>
  <div>
    <el-container style="height:100vh">
      <el-header class="header-con">
        <ul class="content">
          <li class="item" style="position: relative">
            123
            <div class="item-list">
              <ul style="position: absolute">
                <li>123</li>
                <li>123</li>
                <li>123</li>
              </ul>
            </div>
          </li>
          <li class="item">占位</li>
          <li class="item">占位</li>
          <li class="item">占位</li>
        </ul>
      </el-header>
      <router-view/>
    </el-container>
    <div class="footer">@煜策星</div>
  </div>
</template>

<script>
  export default {
    name: 'login',
    data () {
      return {
        titleList: [
          {
            title: '我的问卷',
            url: '/'
          },
          {
            title: '问卷类型'
          }
        ],

      }
    }, methods: {
      toUrl (url) {
        this.$router.push(url)
      }
    }
  }
</script>

<style lang="scss" scoped>
  ul{
    list-style-type: none;
  }
  .header-con{
    position: fixed;
    top:0;
    left:0;
    right:0;
    width:100%;
    .content{
      width: 70%;
      margin:0 auto;
      height:60px;
      line-height: 60px;
      color: #606266;
      font-size: 14px;
      box-sizing: border-box;
      .item{
        padding:0 10px;
        margin:0 15px;
        cursor: pointer;
        float:left;
        transition: all 0.3s;
        .item-list{
          display: none;
          margin-top:5px;
          ul{
            display: flex;
            background:#fff;
            border-radius: 5px;
            li{
              margin:0 10px;
            }
          }
        }

      }
      .item:hover{
        .item-list{
          display: block;
        }
      }
    }
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #fff inset;
  }
  .login-container .el-input input:-webkit-autofill{
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
  }
  .footer{
    height:60px;
    line-height: 60px;
    text-align: center;
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/no-login.vue